import { Link } from "@mui/material";
import SuiTypography from "components/SuiTypography";
import { globaleDateTimeFormatter } from "utils/helper";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { pdf } from "@react-pdf/renderer";
import MyInvoiceDoc from "containers/pdf/billingPdf";
import { canSendInvoiceWhatsApp } from "utils/invoiceHelpers";

const openInvoicePreview = async (item, rowData, user) => {
  if (!user) {
    window.open(item.invoice, "_blank");
    return;
  }

  const previewWindow = window.open("", "_blank");
  try {
    const bill = {
      ...rowData,
      ...item,
      sellerGstNumber:
        item?.sellerGstNumber ||
        rowData?.sellerGstNumber ||
        rowData?.gstNumber ||
        user?.gstNumber,
      complementaryService:
        item?.complementaryService || rowData?.complementaryService,
    };
    const blob = await pdf(
      <MyInvoiceDoc
        user={user}
        bill={bill}
        note={rowData?.termsAndCondition || user.termsAndConditions}
        type={bill?.type}
        termsAndCondition={bill?.termsAndCondition}
      />
    ).toBlob();
    const blobUrl = URL.createObjectURL(blob);

    if (previewWindow) {
      previewWindow.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }
  } catch (error) {
    if (previewWindow) {
      previewWindow.close();
    }
    window.open(item.invoice, "_blank");
  }
};

export const InvoiceHistoryRows = (
  invoiceHistoryArray,
  rowData,
  editHandler,
  handleSendWhatsApp,
  user
) => {
  const rows = invoiceHistoryArray?.map((item, index) => {
    return {
      "S.no": (
        <SuiTypography variant="button" fontWeight="medium">
          {index + 1}
        </SuiTypography>
      ),

      "Generated Date": (
        <SuiTypography variant="button" fontWeight="medium">
          {globaleDateTimeFormatter(item?.date, "date")}
        </SuiTypography>
      ),

      "Invoice No.": (
        <Link
          component="button"
          type="button"
          onClick={() => openInvoicePreview(item, rowData, user)}
        >
          <SuiTypography
            variant="button"
            fontWeight="medium"
            sx={{ color: "#17C1E8" }}
          >
            {item.invoiceId
              ? item.invoiceId
              : globaleDateTimeFormatter(item?.date, "date")}
          </SuiTypography>
        </Link>
      ),

      Balance: (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ color: "red" }}
        >
          INR {item?.balance?.toFixed(2) ? item?.balance?.toFixed(2) : "N/A"}
        </SuiTypography>
      ),

      "Total Amount": (
        <SuiTypography variant="button" fontWeight="medium">
          INR{" "}
          {item?.totalAmount?.toFixed(2)
            ? item?.totalAmount?.toFixed(2)
            : "N/A"}
        </SuiTypography>
      ),
      Action: (
        <>
          <Tooltip title="Edit Invoice" placement="top">
            <EditIcon
              variant="button"
              fontWeight="medium"
              style={{
                color: "#17C1E8",
                cursor: "pointer",
                paddingLeft: 8,
              }}
              onClick={() => editHandler(item, item.type)}
              fontSize="large"
            />
          </Tooltip>

          {canSendInvoiceWhatsApp(item, rowData) ? (
            <Tooltip title="Send on WhatsApp" placement="top">
              <WhatsApp
                style={{
                  color: "#25D366",
                  cursor: "pointer",
                  paddingLeft: 12,
                }}
                onClick={() =>
                  handleSendWhatsApp({ ...rowData, ...item })
                }
                fontSize="large"
              />
            </Tooltip>
          ) : null}
        </>
      ),
    };
  });

  return rows;
};
